module.exports = __webpack_public_path__ + "assets/img/icon-light.fb07e64b.png";